angular.module('env.data.repos.addresses', [])

    .service("addressesRepository", function (rest) {
        var _this = this;
        var modelType = "AddressModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get addresses
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of addresses collection
         */
        _this.getAddresses = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get address by id
         * @param id id of the address
         * @returns {!Promise.<RepresentationModel>} Promise of address
         */
        _this.getAddress = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("AddressModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;